(function () {
  'use strict';

  var STORAGE_KEY = 'stripled_attribution_v1';

  function safeGet() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function safeSet(value) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (e) {}
  }

  function pageUrl(value) {
    try {
      var url = new URL(value || window.location.href, window.location.href);
      return url.origin + url.pathname;
    } catch (e) {
      return value || '';
    }
  }

  function hostOf(value) {
    try {
      return new URL(value).hostname.toLowerCase().replace(/^www\./, '');
    } catch (e) {
      return '';
    }
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isPaidMedium(value) {
    var medium = normalize(value);
    return /(^|[_-])(cpc|ppc|paid|paidsearch|paid_search|paidsocial|paid_social|ads?|display)([_-]|$)/.test(medium);
  }

  function channelFromSource(source, medium, referrer, params) {
    var src = normalize(source);
    var med = normalize(medium);
    var refHost = hostOf(referrer);
    var currentHost = window.location.hostname.toLowerCase().replace(/^www\./, '');

    if (params.get('gclid')) return 'Google Ads';
    if (params.get('fbclid') && !src) return 'Meta Ads (Facebook / Instagram)';

    if (src) {
      if (src === 'ig' || src.indexOf('instagram') !== -1) return isPaidMedium(med) ? 'Instagram Ads' : 'Instagram';
      if (src === 'fb' || src.indexOf('facebook') !== -1) return isPaidMedium(med) ? 'Facebook Ads' : 'Facebook';
      if (src.indexOf('meta') !== -1) return isPaidMedium(med) ? 'Meta Ads (Facebook / Instagram)' : 'Meta (Facebook / Instagram)';
      if (src.indexOf('google') !== -1) return isPaidMedium(med) ? 'Google Ads' : 'Google';
      if (src.indexOf('bing') !== -1 || src.indexOf('microsoft') !== -1) return isPaidMedium(med) ? 'Microsoft Ads' : 'Bing';
      if (src.indexOf('tiktok') !== -1) return isPaidMedium(med) ? 'TikTok Ads' : 'TikTok';
      if (src.indexOf('youtube') !== -1) return 'YouTube';
      if (src.indexOf('whatsapp') !== -1) return 'WhatsApp';
      if (src.indexOf('newsletter') !== -1 || src.indexOf('email') !== -1 || med === 'email') return 'Email / Newsletter';
      return source;
    }

    if (refHost) {
      if (refHost === currentHost || refHost.endsWith('.' + currentHost)) return 'Sito interno';
      if (refHost.indexOf('instagram.') !== -1) return 'Instagram';
      if (refHost.indexOf('facebook.') !== -1 || refHost === 'l.facebook.com' || refHost === 'lm.facebook.com') return 'Facebook';
      if (refHost.indexOf('google.') !== -1) return 'Google organico';
      if (refHost.indexOf('bing.') !== -1) return 'Bing organico';
      if (refHost.indexOf('tiktok.') !== -1) return 'TikTok';
      if (refHost.indexOf('youtube.') !== -1 || refHost.indexOf('youtu.be') !== -1) return 'YouTube';
      return 'Referral: ' + refHost;
    }

    return 'Diretto';
  }

  function captureFirstTouch() {
    var existing = safeGet();
    if (existing && existing.entryPage) return existing;

    var params = new URLSearchParams(window.location.search);
    var source = params.get('utm_source') || '';
    var medium = params.get('utm_medium') || '';
    var referrer = document.referrer || '';

    var data = {
      channel: channelFromSource(source, medium, referrer, params),
      utmSource: source,
      utmMedium: medium,
      utmCampaign: params.get('utm_campaign') || '',
      utmContent: params.get('utm_content') || '',
      utmTerm: params.get('utm_term') || '',
      entryPage: pageUrl(window.location.href),
      initialReferrer: referrer ? pageUrl(referrer) : '',
      capturedAt: new Date().toISOString()
    };

    safeSet(data);
    return data;
  }

  function conversionAccess(data) {
    var referrer = document.referrer || '';
    var refHost = hostOf(referrer);
    var currentHost = window.location.hostname.toLowerCase().replace(/^www\./, '');
    var currentPage = pageUrl(window.location.href);

    if (refHost && (refHost === currentHost || refHost.endsWith('.' + currentHost))) {
      return 'Sito interno';
    }

    if (data.entryPage === currentPage && data.channel === 'Diretto') {
      return 'Diretto alla pagina';
    }

    if (data.channel && data.channel !== 'Diretto' && data.channel !== 'Sito interno') {
      return 'Canale esterno';
    }

    return 'Navigazione diretta';
  }

  function getData() {
    var first = captureFirstTouch();
    return {
      channel: first.channel || 'Diretto',
      conversionAccess: conversionAccess(first),
      utmSource: first.utmSource || '',
      utmMedium: first.utmMedium || '',
      utmCampaign: first.utmCampaign || '',
      utmContent: first.utmContent || '',
      utmTerm: first.utmTerm || '',
      entryPage: first.entryPage || '',
      initialReferrer: first.initialReferrer || '',
      previousPage: document.referrer ? pageUrl(document.referrer) : '',
      conversionPage: pageUrl(window.location.href)
    };
  }

  function fillForm(form) {
    if (!form || !form.querySelectorAll) return;
    var data = getData();
    var fields = form.querySelectorAll('[data-sl-attribution]');
    fields.forEach(function (field) {
      var key = field.getAttribute('data-sl-attribution');
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        field.value = data[key] || '';
      }
    });
  }

  function fillAll() {
    document.querySelectorAll('form').forEach(fillForm);
  }

  window.StripledAttribution = {
    get: getData,
    fillForm: fillForm,
    fillAll: fillAll
  };

  captureFirstTouch();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillAll, { once: true });
  } else {
    fillAll();
  }

  document.addEventListener('submit', function (event) {
    fillForm(event.target);
  }, true);
})();
